module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu",
    class: _vm.classes
  }, [_c('div', {
    staticClass: "menu__background"
  }), _vm._v(" "), _c('div', {
    staticClass: "menu__container"
  }, [_c('div', {
    staticClass: "menu__rmn"
  }, [_c('a', {
    attrs: {
      "href": "http://www.grandpalais.fr/fr/evenement/jardins",
      "target": "_blank"
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isTransparent),
      expression: "isTransparent"
    }],
    attrs: {
      "src": "/static/assets/img/logo_rmn.png",
      "alt": "Rmn"
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isTransparent),
      expression: "!isTransparent"
    }],
    attrs: {
      "src": "/static/assets/img/logo_rmn_black.png",
      "alt": "Rmn"
    }
  })])]), _vm._v(" "), _c('router-link', {
    staticClass: "menu__home-link",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('div', {
    staticClass: "menu__title"
  }, [_c('span', {
    staticClass: "title__big"
  }, [_vm._v("Secrets")]), _vm._v(" "), _c('span', {
    staticClass: "title__small"
  }, [_vm._v("et")]), _vm._v(" "), _c('span', {
    staticClass: "title__big"
  }, [_vm._v("Vertus")]), _vm._v(" "), _c('span', {
    staticClass: "title__small"
  }, [_vm._v("des")]), _vm._v(" "), _c('span', {
    staticClass: "title__big"
  }, [_vm._v("Plantes")])])]), _vm._v(" "), _c('div', {
    staticClass: "menu__btns"
  }, [_c('ui-button', {
    attrs: {
      "shareInfos": _vm.shareInfos(),
      "type": "sound",
      "isTransparent": _vm.isTransparent
    }
  }), _vm._v(" "), _c('ui-button', {
    attrs: {
      "shareInfos": _vm.shareInfos(),
      "type": "facebook",
      "isTransparent": _vm.isTransparent
    }
  }), _vm._v(" "), _c('ui-button', {
    attrs: {
      "shareInfos": _vm.shareInfos(),
      "type": "twitter",
      "isTransparent": _vm.isTransparent
    }
  })], 1)], 1)])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-72f7c74d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UI/Menu.vue
 ** module id = 753
 ** module chunks = 2
 **/